<div class="tee-times-root">
    <div class="sticky-banner">
        <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Tee Times'" [sponsor_key]="'golf-tee-times'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
    </div>

    @if (isLoading) {
        <div class="scroll-section">
            <app-loading-indicator></app-loading-indicator>
        </div>
    } @else {
        <div class="tee-loaded">
            <div class="filters-row">
                <mat-form-field class="filter-select" appearance="outline">
                    <mat-select [formControl]="roundPicker">
                        @for (r of availableRounds; track r) {
                            <mat-option [value]="r.value">
                                {{ appStrings.getAppString(r.labelKey) }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="filter-search" appearance="outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="text" [formControl]="search" [placeholder]="searchPlaceholder" />
                    @if (search.value) {
                        <button class="clear-btn" mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch($event)">
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
            </div>
        </div>
        @if (showEmpty) {
            <div class="empty-state">
                <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
                <h2>{{ appStrings.getAppString('golf.teetimes.empty.title') }}</h2>
                <p>{{ appStrings.getAppString('golf.teetimes.empty.body') }}</p>
            </div>
        } @else {
            <div class="scroll-section">
                <table mat-table [dataSource]="rowsFiltered">
                    <!-- Player -->
                    <ng-container matColumnDef="player">
                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                            {{ appStrings.getAppString('golf.leaderboard.player') }}
                        </th>
                        <td mat-cell *matCellDef="let row" class="player-td">
                            <div class="player-cell">
                                <app-image
                                    class="player-avatar"
                                    [display_flag]="true"
                                    [player]="row.player"
                                    [app_country_flag_width]="'1.2rem'"
                                    [country_flag_left]="'2.05rem'"
                                    [country_flag_top]="'0.15rem'"
                                    [width]="'42px'"
                                    [height]="'42px'"
                                    [margin]="'0'"
                                ></app-image>
                                <div class="player-name-wrap">
                                    <span class="player-name">{{ row.fullName }}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <!-- Time -->
                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                            {{ appStrings.getAppString('golf.teetimes.time') }}
                        </th>
                        <td mat-cell *matCellDef="let row">{{ row.teeTimeDisplay }}</td>
                    </ng-container>
                    <!-- Tee -->
                    <ng-container matColumnDef="tee">
                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                            {{ appStrings.getAppString('golf.teetimes.tee') }}
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <div class="tee-cell">
                                <div class="tee-number">{{ row.startingHole ?? '-' }}</div>
                                @if ((golfTour?.courses?.length ?? 0) > 1 && row.courseAbbreviation) {
                                    <div class="tee-course-abbrev">({{ row.courseAbbreviation }})</div>
                                }
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr (click)="openPlayer(row?.player)" style="cursor: pointer" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        }
    }
</div>
